import React, { forwardRef } from 'react';
import JobPostForm from '../../components/JobBoard/Post/JobPostForm';

const JobPost = forwardRef((props, ref) => {
  return (
    // 모바일은 위저드가 자체 헤더·하단바를 갖고 화면을 꽉 채우므로 래퍼 여백을 주지 않는다
    <div className='flex justify-center bg-grayscale-gray00 tabletH:px-[80px] tabletH:pb-[240px] tabletH:pt-[60px]'>
      <JobPostForm ref={ref} />
    </div>
  );
});

export default JobPost;
